// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ChakraHealingPage from "../pages/ChakraHealing/ChakraHealing";
const __wvcRoutePaths = ["/ChakraHealingPage", "/chakra-heilung"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutmepage", "angebote", "angebotepage", "chakra-heilung", "chakrahealingpage", "contactpage", "homepage", "kontakt", "post", "reiki-therapie", "reikitherapypage", "retreats", "retreatspage", "startseite", "uber-mich"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ChakraHealingPage />} />
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ChakraHealingPage />} />
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
